<h3-point-cloud-content-initializer
  [project]="taskWorkspaceStore.state().project"
  [output]="outputInfoStore.state().output"
  [readOnly]="taskWorkspaceStore('readOnly').$ | async"
  [isClientFeedbacksEditable]="isClientFeedbacksEditable"
  [isShapeFeedbackEditable]="isShapeFeedbackEditable"
  [currentUser]="taskWorkspaceStore.state().currentUser"
  [stepId]="taskWorkspaceStore.state().stepId"
  [frameNumber]="fusionStore.state().frameNumber"
  (initializationComplete)="onContentInitialized($event)"
></h3-point-cloud-content-initializer>

@if (contentInjector) {
  <h3-point-cloud-layout></h3-point-cloud-layout>

  @if (showAddRandomShapes$ | async) {
    <ng-container *h3Injector="contentInjector">
      <hr />
      <h3-generate-random-points></h3-generate-random-points>
      <hr />
      <h3-add-random-cuboids></h3-add-random-cuboids>
      <hr />
      <h3-modify-asset-bounding-box></h3-modify-asset-bounding-box>
    </ng-container>
  }
}
